<div
    mat-dialog-title
    class="dialog-header"
>
    <p class="title">
        <mat-icon
            [fontSet]="data.fontSet"
            [svgIcon]="data.svgIcon"
        >
            {{ data.icon }}
        </mat-icon>
        <span>{{ data.title }}</span>
    </p>

    <button
        mat-dialog-close
        mat-icon-button
        class="absolute right-2 top-2"
    >
        <mat-icon>close</mat-icon>
    </button>
</div>
<div
    mat-dialog-content
    class="dialog-content flex h-full max-h-full flex-col py-4"
>
    <div *ngIf="data.gridFormElementDetailDialogTemplate">
        <ng-container
            *ngTemplateOutlet="
                data.gridFormElementDetailDialogTemplate?.templateRef;
                context: { $implicit: dialogRef, data }
            "
        >
        </ng-container>
    </div>
</div>
